export default "__VITE_ASSET__CGwGAxqr__"